import axios from 'axios';
import useSWR from 'swr';

const useRequestLogAnalytics = (filters = {}) => {
  const searchParams = new URLSearchParams();

  if (filters.startDate) {
    const startOfDay = new Date(filters.startDate + 'T00:00:00.000');
    searchParams.set('start_ts_gte', startOfDay.toISOString());
  }
  if (filters.endDate) {
    const endOfDay = new Date(filters.endDate + 'T23:59:59.999');
    searchParams.set('start_ts_lte', endOfDay.toISOString());
  }
  if (filters.methods && filters.methods.length > 0) {
    searchParams.set('method', filters.methods.join(','));
  }
  if (filters.routeGroup && filters.routeGroup !== 'all') {
    searchParams.set('route_group', filters.routeGroup);
  }
  if (filters.source && filters.source !== 'all') {
    searchParams.set('source', filters.source);
  }
  if (filters.statusFilter && filters.statusFilter !== 'all') {
    searchParams.set('status_code_prefix', filters.statusFilter.replace('xx', ''));
  }

  const url = `/admin/request-log/dashboard-analytics?${searchParams.toString()}`;

  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useRequestLogAnalytics };
